module.exports = __webpack_public_path__ + "img/logo-black.10fa9bc4.svg";